import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import "../card.css";
import UserContext from "../context/UserContext";
import DesktopViewContext from "../context/DesktopViewContext";
const Why = ({}) => {
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const [userPicture, setUserPicture] = useState(null);
  const { desktopView } = useContext(DesktopViewContext);
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
  const navigateToCreateJob = () => {
    navigate("/createjob");
  };
  const onSuccess = async (res) => {
    const decodedUser = jwtDecode(res.credential);
    localStorage.setItem("user", JSON.stringify(decodedUser));

    setUser(decodedUser);
    setUserPicture(decodedUser.picture);
    try {
      const response = await fetch(api_endpoint + "/api/users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "google-id": decodedUser.sub,
          name: decodedUser.name,
          email: decodedUser.email,
        },
      });

      const data = await response.json();
      console.log("Server response:", data);

      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("picture", JSON.stringify(decodedUser.picture));
        setUser(data.user);
      }
    } catch (error) {
      console.error("Error inserting user:", error);
    }

    navigate("/");
  };
  return (
    <>
      <div className="box-container">
        <div className="box-item">
          <div
            className="flip-box"
            style={{
              minWidth: !desktopView ? "70vw" : "30vw"
            }}
          >
            <div className="flip-box-front text-center">
              <div className="inner color-white">
                <h3 className="flip-box-header">Sofőrök Számára</h3>
                <img
                  src="https://s25.postimg.cc/65hsttv9b/cta-arrow.png"
                  alt=""
                  className="flip-box-img"
                />
              </div>
            </div>
            <div className="flip-box-back text-center">
              <div className="inner color-white">
                <p>Gyors és egyszerű jelentkezési lehetőség önéletrajz feltöltése nélkül.</p>

                <p> Széles választékban találhatóak az állásajánlatok.</p>{" "}
                <p> Képességek szerinti keresés.</p>
                <p>
                  Ha nyitott munkára, akkor a cégek fogják keresni önt előre, az
                  ön által beállított kritériumok alapján.
                </p>
                  <GoogleLogin
                    onSuccess={onSuccess}
                    onError={(error) => console.log("Error:", error)}
                    theme="filled_blue"
                    shape="pill"
                    size="large"
                    logo_alignment="center" 
                    style={{ 
                    width:50,
                    height:50  
                }}
                  />
              </div>
            </div>
          </div>
        </div>
        <div className="box-item">
          <div
            className="flip-box"
            style={{
              minWidth: !desktopView ? "70vw" : "30vw"
            }}
          >
            <div className="flip-box-front text-center">
              <div className="inner color-white">
                <h3 className="flip-box-header">Hirdető Cégek Számára</h3>

                <img
                  src="https://s25.postimg.cc/65hsttv9b/cta-arrow.png"
                  alt=""
                  className="flip-box-img"
                />
              </div>
            </div>
            <div className="flip-box-back text-center">
              <div className="inner color-white">
                <p>Gyors Toborzási Folyamat. </p>
                <p>Célzott Hirdetések. </p>
                <p>Videós Bemutatkozási Lehetőség. </p>
                <button onClick={navigateToCreateJob} className="flip-box-button" style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '90%'}}>
                  Bővebben ide kattintva
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Why;
